/**
 * brand-admin 组件尺寸常量
 *
 * 与 antd-reset.css §1 中的 --comp-* CSS 变量一一对应。
 * App.vue 的 ConfigProvider token 引用此文件，保证 CSS 和 JS 两端数值一致。
 *
 * 使用方式：
 *   import { SIZES } from '@/styles/tokens';
 *   Button: { borderRadius: SIZES.controlRadius, ... }
 *
 * 修改规范：
 *   改尺寸 → 只改此处 + 同步 antd-reset.css :root 中同名 CSS 变量
 */

export const SIZES = {
  /** 控件高度：Button / Input / Select / DatePicker */
  controlHeight: 36,
  /** 控件高度-大 */
  controlHeightLg: 40,
  /** 控件高度-小 */
  controlHeightSm: 28,
  /** 控件高度-超小（Pagination item） */
  controlHeightXs: 32,

  /** 控件圆角：Button / Input / Select / DatePicker */
  controlRadius: 6,
  /** 控件圆角-大：Tag / Pagination / Menu item */
  controlRadiusLg: 10,

  /** 卡片圆角 */
  cardRadius: 12,
  /** 表格圆角 */
  tableRadius: 12,

  /** 内边距-小（Input padding / Table cell padding-h） */
  paddingSm: 12,
  /** 内边距-中（Button padding / Table cell padding-v） */
  paddingMd: 16,
  /** 内边距-大（Card body padding / Button LG padding） */
  paddingLg: 20,

  /** 表格表头高度 */
  tableHeaderHeight: 46,
  /** 表格行高 */
  tableRowHeight: 52,
};

export const TYPOGRAPHY = {
  /**
   * 后台系统字体栈。
   * 优先使用系统中文字体，避免额外字体资源影响首屏加载。
   */
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Noto Sans SC", "Helvetica Neue", Arial, sans-serif',

  /** 辅助说明、表单错误提示 */
  fontSizeXs: 12,
  /** 表格正文、弱提示 */
  fontSizeSm: 13,
  /** 默认正文 */
  fontSizeBase: 14,
  /** 模块标题 */
  fontSizeMd: 15,
  /** 页面二级标题 */
  fontSizeLg: 16,
  /** 页面主标题 */
  fontSizeXl: 18,
  /** 强调数字 */
  fontSizeXxl: 24,
  /** 数据看板数字 */
  fontSize3xl: 30,
  /** 图标数字 */
  fontSize4xl: 36,

  lineHeightTight: 1.45,
  lineHeightBase: 1.5715,
  lineHeightLoose: 1.7,

  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemibold: 600,
};
